// GET SITE LIST
export const SITE_DATA = "SITE_DATA"
export const SITE_DATA_SUCCESS = "SITE_DATA_SUCCESS"
export const ALL_SITE_DATA_SUCCESS = "ALL_SITE_DATA_SUCCESS"
export const SITE_DATA_ERROR = "SITE_DATA_ERROR"
export const GETALLSITES = "GETALLSITES"
export const SITE_LIST_SUCCESS = "SITE_LIST_SUCCESS"
export const SITES_LIST_SUCCESS='SITE_LIST_SUCCESS'
export const SITE_DATA_DROPDOWN = "SITE_DATA_DROPDOWN"
export const SITEDROPDOWN_LIST_SUCCESS='SITEDROPDOWN_LIST_SUCCESS'
// ADD NEW SITE
export const ADD_NEW_SITE = "ADD_NEW_SITE"
export const ADD_NEW_SITE_SUCCESS = "ADD_NEW_SITE_SUCCESS"
export const ADD_NEW_SITE_ERROR = "ADD_NEW_SITE_ERROR"

// UPDATE SITE
export const UPDATE_NEW_SITE = "UPDATE_NEW_SITE"
export const UPDATE_NEW_SITE_SUCCESS = "UPDATE_NEW_SITE_SUCCESS"
export const UPDATE_NEW_SITE_ERROR = "UPDATE_NEW_SITE_ERROR"

//DELETE SITE 
export const DELETE_SITE_BYID = "DELETE_SITE_BYID"
export const DELETE_SITE_SUCCESS = "DELETE_SITE_SUCCESS"
export const DELETE_SITE_ERROR = "DELETE_SITE_ERROR"

//Get Manual by siteid
 export const MANUAL_DATA = "MANUAL_DATA"
export const MANUAL_DATA_SUCCESS = "MANUAL_DATA_SUCCESS"
export const ALL_MANUAL_DATA_SUCCESS = "ALL_MANUAL_DATA_SUCCESS"
export const MANUAL_DATA_ERROR = "MANUAL_DATA_ERROR"

export const MANUAL_BY_SITEID = "MANUAL_BY_SITEID"
//Get Drawing by siteid
export const DRAWING_DATA = "DRAWING_DATA"
export const DRAWING_DATA_SUCCESS = "DRAWING_DATA_SUCCESS"
export const ALL_DRAWING_DATA_SUCCESS = "ALL_DRAWING_DATA_SUCCESS"
export const DRAWING_DATA_ERROR = "DRAWING_DATA_ERROR"

//Get ChangeRequest by siteid
export const ADD_CHANGEREQUEST = "ADD_CHANGEREQUEST"
export const ADD_CHANGEREQUEST_SUCCESS = "ADD_CHANGEREQUEST_SUCCESS"
export const ADD_CHANGEREQUEST_ERROR = "ADD_CHANGEREQUEST_ERROR"
export const CHANGEREQUEST_BY_SITEID = "CHANGEREQUEST_BY_SITEID"
export const CHANGEREQUEST_BY_SITEID_SUCCESS = "CHANGEREQUEST_BY_SITEID_SUCCESS"
export const CHANGEREQUEST_BY_SITEID_ERROR = "CHANGEREQUEST_BY_SITEID_ERROR"


export const BULK_UPLOAD = "BULK_UPLOAD"